import { Freeform } from 'components/common/Freeform';
import { parseBlocks } from 'services/parseUtils/parseBlocks';
import { AgilityPageProps } from 'types/AgilityTypes';

interface StaticContentFields {
  content: string;
}

const StaticContent: React.FC<AgilityPageProps<StaticContentFields>> = ({
  module,
}) => {
  const fields: StaticContentFields | undefined = module.fields;
  if (!fields) {
    return null;
  }
  const blocks = parseBlocks(fields.content);
  return <Freeform blocks={blocks} />;
};

export default StaticContent;
